/**
 * Request Domain Constants
 * Single source of truth for request-related constants
 */

// Request status codes (matching backend/database values)
export const REQUEST_STATUS = {
  DRAFT: 'draft',
  NEW: 'new',
  PENDING: 'pending',
  SEND_BACK: 'sbk',
  APPROVED: 'app',
  REJECTED: 'rej',
  REVIEW: 'review',
  IN_PROGRESS: 'in_progress',
  ASSIGNED: 'assigned',
};

export const REQUEST_TAGS = {
  NEW: 'new',
  SENT_BACK: 'sent_back',
  RESUBMITTED: 'resubmitted',
  UNDER_SUBMISSION: 'under_submission',
  UNDER_REVIEW: 'under_review',
};

export const TAG_COLORS = {
  [REQUEST_TAGS.NEW]: '#007bff', // Blue
  [REQUEST_TAGS.SENT_BACK]: '#d9534f', // Red
  [REQUEST_TAGS.RESUBMITTED]: '#33d00c', // Green
  [REQUEST_TAGS.UNDER_SUBMISSION]: '#007bff', // Blue
  [REQUEST_TAGS.UNDER_REVIEW]: '#007bff', // Blue
};

export const REVIEWER_STATUS_ORDER = [
  REQUEST_STATUS.ASSIGNED,
  REQUEST_STATUS.PENDING,
  REQUEST_STATUS.APPROVED,
  REQUEST_STATUS.REJECTED,
];

export const CUSTOMER_STATUS_ORDER = [
  REQUEST_STATUS.PENDING,
  REQUEST_STATUS.IN_PROGRESS,
  REQUEST_STATUS.APPROVED,
  REQUEST_STATUS.REJECTED,
  REQUEST_STATUS.DRAFT,
];

// Tab state keys for localStorage persistence
export const TAB_STATE_KEYS = {
  ADMIN_APPROVALS: 'admin_approvals',
  CUSTOMER_MY_REQUESTS: 'customer_my_requests',
};

// Action types for request progress
export const REQUEST_ACTIONS = {
  APPROVED: 'approved',
  REJECTED: 'rejected',
  SEND_BACK: 'sendback',
};

// Priority levels for request badges
export const PRIORITY_LEVELS = {
  CRITICAL: 'critical',
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
};

// Priority badge colors (hex values)
export const PRIORITY_COLORS = {
  [PRIORITY_LEVELS.CRITICAL]: '#d40000',
  [PRIORITY_LEVELS.HIGH]: '#e6750c',
  [PRIORITY_LEVELS.MEDIUM]: '#ddbb08',
  [PRIORITY_LEVELS.LOW]: '#33d00c',
  DEFAULT: '#6e6e6e',
};

export const REVIEWER_TAG_OPTIONS = {
  [REQUEST_STATUS.ASSIGNED]: [
    REQUEST_TAGS.NEW,
    REQUEST_TAGS.RESUBMITTED,
    REQUEST_TAGS.SENT_BACK,
  ],
  [REQUEST_STATUS.PENDING]: [
    REQUEST_TAGS.UNDER_SUBMISSION,
    REQUEST_TAGS.UNDER_REVIEW,
  ],
};

export const CUSTOMER_TAG_OPTIONS = {
  [REQUEST_STATUS.PENDING]: [REQUEST_TAGS.NEW, REQUEST_TAGS.SENT_BACK],
  [REQUEST_STATUS.IN_PROGRESS]: [
    REQUEST_TAGS.UNDER_SUBMISSION,
    REQUEST_TAGS.UNDER_REVIEW,
  ],
};
